/**
 * H5 登录/注册接口（对接 Pear-Admin-Think /index.php/api/auth/*）
 */
const BASE = (typeof process !== 'undefined' && process.env?.VUE_APP_API_BASE) || '/api'
const TOKEN_KEY = 'h5_token'

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || ''
  } catch {
    return ''
  }
}

export function setStoredToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token)
    else localStorage.removeItem(TOKEN_KEY)
  } catch (_) { /* ignore localStorage errors */ }
}

function request(method, path, body = null) {
  const token = getStoredToken()
  const opts = {
    method,
    credentials: 'omit',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Token: token } : {})
    }
  }
  if (body && (method === 'POST' || method === 'PUT')) {
    opts.body = JSON.stringify(body)
  }
  return fetch(BASE + path, opts)
    .then(res => res.json())
    .then(data => {
      if (data.code !== 200 && data.code !== 0) throw new Error(data.msg || '请求失败')
      return data
    })
}

export default {
  /** 登录：account(用户名或手机), password → { token, data: user } */
  login(account, password) {
    return request('POST', '/auth/login', { account, password }).then(r => ({
      token: r.token,
      user: r.data
    }))
  },
  /** 注册：username, mobile, password → { token, data: user } */
  register(data) {
    return request('POST', '/auth/register', data).then(r => ({
      token: r.token,
      user: r.data
    }))
  },
  /** 当前用户（需 token） */
  userInfo() {
    return request('GET', '/auth/userInfo').then(r => r.data)
  },
  /** 退出 */
  logout() {
    return request('POST', '/auth/logout').finally(() => setStoredToken(''))
  },
  getStoredToken,
  setStoredToken
}
